import Link from '@mui/material/Link';
import { Link as RouterLink, useLocation } from 'react-router';

interface PropTypes {
  title: string;
  id: string;
  to: string;
  colorInvert?: boolean;
}

function NavItem(props: PropTypes): JSX.Element {
  const { title, id, colorInvert = false } = props;
  const { pathname } = useLocation();

  const hasActiveLink = props.to === pathname;
  const linkColor = colorInvert ? 'common.white' : 'text.primary';

  return (
    <Link
      id={id}
      component={RouterLink}
      to={props.to}
      underline="none"
      sx={{
        fontWeight: hasActiveLink ? 700 : 400,
        color: linkColor,
        cursor: 'pointer',
      }}
    >
      {title}
    </Link>
  );
}

export default NavItem;
